export  const siteVisitSvg = `<?xml version="1.0" encoding="utf-8"?>

<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#1394db" height="800px" width="800px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 32 32" xml:space="preserve">
<g>
	<path d="M21,24h3c0.6,0,1-0.4,1-1v-3h-5v3C20,23.6,20.4,24,21,24z"/>
	<path d="M8,24h3c0.6,0,1-0.4,1-1v-3H7v3C7,23.6,7.4,24,8,24z"/>
</g>
<g>
	<path d="M15,23h-1c0,1.7-1.3,3-3,3H8c-1.7,0-3-1.3-3-3H2v6c0,0.6,0.4,1,1,1h9c1.1,0,2.2-0.4,3-1V23z"/>
	<path d="M27,23c0,1.7-1.3,3-3,3h-3c-1.7,0-3-1.3-3-3h-1v6c0.8,0.7,1.9,1,3,1h9c0.6,0,1-0.4,1-1v-6H27z"/>
</g>
<g>
	<path d="M15,21v-4H2v4h3v-2c0-0.6,0.4-1,1-1h7c0.6,0,1,0.4,1,1v2H15z"/>
	<path d="M17,17v4h1v-2c0-0.6,0.4-1,1-1h7c0.6,0,1,0.4,1,1v2h3v-4H17z"/>
</g>
<g>
	<path d="M17,15h13c0-0.5-0.3-0.9-0.8-1c-1.9-0.5-3.2-2.2-3.2-4.2V3c0-0.6-0.4-1-1-1h-3c-0.4,0-0.7,0.2-0.9,0.5L17,9.4V15z"/>
	<path d="M15,9.4l-4.1-6.9C10.7,2.2,10.4,2,10,2H7C6.4,2,6,2.4,6,3v6.9c0,2-1.3,3.7-3.2,4.2C2.3,14.1,2,14.5,2,15h13V9.4z"/>
</g>
</svg>`;